export default __webpack_public_path__ + "static/media/cloud3.290a3452.svg";